import React from 'react';

const CalorieRing = ({ consumed = 0, goal = 1, exercise = 0, size = 130, stroke = 12 }) => {
  const radius = (size - stroke) / 2;
  const circumference = 2 * Math.PI * radius;
  const adjusted = Math.max(0, goal - exercise);
  const percent = Math.min(1, consumed / adjusted);
  const dashOffset = circumference * (1 - percent);
  const remaining = goal - consumed + exercise;
  const isOver = remaining < 0;

  return (
    <div className="relative" style={{ width: size, height: size }}>
      <svg width={size} height={size} className="-rotate-90">
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          stroke="#eef2f7"
          strokeWidth={stroke}
          fill="none"
        />
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          stroke={isOver ? '#ef4444' : '#0066ee'}
          strokeWidth={stroke}
          fill="none"
          strokeLinecap="round"
          strokeDasharray={circumference}
          strokeDashoffset={dashOffset}
          style={{ transition: 'stroke-dashoffset 900ms cubic-bezier(0.22, 1, 0.36, 1)' }}
        />
      </svg>
      <div className="absolute inset-0 flex flex-col items-center justify-center">
        <span className={`text-2xl font-bold ${isOver ? 'text-red-500' : 'text-gray-900'}`}>
          {Math.abs(remaining).toLocaleString()}
        </span>
        <span className="text-[11px] text-gray-500 uppercase tracking-wider mt-0.5">
          {isOver ? 'Over' : 'Remaining'}
        </span>
      </div>
    </div>
  );
};

export default CalorieRing;
